module.exports = __webpack_public_path__ + "images/icons_v2/recycle-02404d63.svg";